<template>
  <div class="leftbar-view elffy-dashboard" :class="{'left-aside-toggle': toggle_aside}">
    <!--Page Container Start Here-->
    <section class="main-container">
      <div class="container-fluid">
        <div class="row">
        	<div class="col-md-3">
        		<div class="widget-wrap">
		          <div class="widget-header block-header margin-bottom-0 clearfix">
		            <div class="text-left">
		              <h3>知識分類 
		              	<a href="" class="btn btn-default pull-right btn-xs text-gray">
		              		<i class="fa fa-plus"></i>
		              	</a>
		              </h3>
		            </div>
		          </div>
		          <div class="widget-container">
		            <Container
					        @drop="onCategoryDrop($event)"
					        drag-handle-selector=".column-drag-handle"
					        @drag-start="dragStart"
					        :drop-placeholder="dropItemPlaceholderOptions"
					        :lock-axis="'y'"
					      >
					        <Draggable v-for="c in categories" :key="c.token">
	    							<div class="column-drag-handle text-left icon-list">
	    								<i :class="c.icon"></i> 
	    								<div class="icon-list-content">
	    									{{c.name}} ({{c.blogs.length}})
	    								</div>
	    							</div>
			    				</Draggable>
			    			</Container>
		          </div>
		        </div>
		        <div class="widget-wrap">
		        	<strong class="text-success">知識庫是企業的軟性資產</strong>
		        	<p>累積各種產業知識，相關作法、SOP、員工教育訓練..等等重要知識性文件，將可大幅減少相關支出，同時累積企業的內部價值</p>
		        </div>
        	</div>
        	<div class="col-md-9">
        		<!-- 如果文章是空的，顯示分類列表 -->
        		<div v-if="blog==''" class="widget-wrap" style="padding: 30px;">
					    <div class="widget-header block-header margin-bottom-0 clearfix">
				        <div class="pull-left pointer" >
				           <h3><strong>{{category.name}}</strong> <i class="fa fa-pencil-alt"></i> ({{category.blogs.length}})</h3>
				        </div>
				        <a href="" class="btn btn-danger pull-right btn-xs">
              		<i class="fa fa-trash"></i>
              	</a>
				        <a href="" class="btn btn-default pull-right btn-xs text-gray mr-3">
              		<i class="fa fa-plus"></i>
              	</a>
					    </div>
					    <div class="widget-container margin-top-0">
				        <div class="widget-content">
			            <div class="task-widget">
                    <Container
							        @drop="onItemDrop($event)"
							        drag-handle-selector=".column-drag-handle"
							        @drag-start="dragStart"
							        :lock-axis="'y'"
							        :drop-placeholder="dropItemPlaceholderOptions"
							        class="widget-task-list todo-tasklist"
							      >
							        <Draggable v-for="b in category.blogs" :key="b.token" class="task-entry p-2 pl-4 pr-4">
			    							<div class="column-drag-handle text-left task-intro" @click="blog = b">
			    								<div class="row align-items-center">
			    									<div class="col-6">
			    										<h5 class="m-0"><i class="fa fa-lock" v-if="b.locked"></i> {{b.name}} </h5>
			    									</div>
			    									<div class="col-2">
			    										<img :src="b.user.avatar" class="avatar-size"> {{b.user.name}}
			    									</div>
			    									<div class="col-2">
			    										{{b.created_at}}
			    									</div>
			    									<div class="col-2">
			    										<i class="fas fa-eye"></i> {{b.views}}
			    									</div>
			    								</div>
			    							</div>
					    				</Draggable>
					    			</Container>
			            </div>
				        </div>
					    </div>
						</div>
						<div v-else class="widget-wrap" style="padding: 30px;">
					    <div class="widget-header block-header margin-bottom-0 clearfix">
				        <div class="pull-left pointer" >
				           <h3>{{category.name}} <i class="fas fa-chevron-right"></i> <strong>{{blog.name}}</strong> <i class="fa fa-pencil-alt"></i></h3>
				        </div>
				        <a href="" class="btn btn-danger pull-right btn-xs">
              		<i class="fa fa-trash"></i>
              	</a>	              	
					    </div>
					    <div class="widget-container margin-top-0">
				        <div class="widget-content">
			            <div class="task-widget">
                    <Container
							        @drop="onItemDrop($event)"
							        drag-handle-selector=".column-drag-handle"
							        @drag-start="dragStart"
							        :lock-axis="'y'"
							        :drop-placeholder="dropItemPlaceholderOptions"
							        class="widget-task-list todo-tasklist"
							      >
							        <Draggable v-for="blog in category.blogs" :key="blog.token" class="task-entry p-2 pl-4 pr-4">
			    							<div class="column-drag-handle text-left task-intro">
			    								<div class="row align-items-center">
			    									<div class="col-6">
			    										<h5 class="m-0"><i class="fa fa-lock" v-if="blog.locked"></i> {{blog.name}} </h5>
			    									</div>
			    									<div class="col-2">
			    										<img :src="blog.user.avatar" class="avatar-size"> {{blog.user.name}}
			    									</div>
			    									<div class="col-2">
			    										{{blog.created_at}}
			    									</div>
			    									<div class="col-2">
			    										<i class="fas fa-eye"></i> {{blog.views}}
			    									</div>
			    								</div>
			    							</div>
					    				</Draggable>
					    			</Container>
			            </div>
				        </div>
					    </div>
						</div>
        	</div>
        </div>
      </div>
    </section>
    <!--Page Container End Here-->
  </div>
</template>

<script>
import { getCookie, setCookie } from '../../assets/js/elffy_js/cookie.js'
import { Container, Draggable } from "vue-smooth-dnd";
import { applyDrag, generateItems } from '../../utils/dragHelpers'
import { getArrayItemById, getArrayItem } from '../../utils/commonHelpers'

export default {
  name: 'knowledge_base_board',
  components: {
  	Container, Draggable
  },
  data() {
    return {
      temp_money_category: {},
    	categories: [
    		{'icon': 'fas fa-dollar-sign','name': '財務相關', 'token': 'ndasdpoqj' ,'blogs': [
	    		{'name': '每月發票處理方式' , 'token': 'dnpwpoj' ,'views': 123 , 'user_avatar': '' ,'user': {'name': 'Tim Tsai', 'avatar': 'https://i0.wp.com/blog.longwin.com.tw/wp-content/uploads/2011/10/apple_hero_steve_jobs.png?fit=706%2C644&ssl=1'} ,'created_at': '2020-06-12', 'locked': true},
	    		{'name': '報稅流程' , 'token': 'dnpwpoj' ,'views': 123 , 'user_avatar': '' ,'user': {'name': 'Tim Tsai', 'avatar': 'https://i0.wp.com/blog.longwin.com.tw/wp-content/uploads/2011/10/apple_hero_steve_jobs.png?fit=706%2C644&ssl=1'} ,'created_at': '2020-06-12', 'locked': false},
    		]},
    		{'icon': 'fas fa-dollar-sign','name': '伺服器相關', 'token': 'ndasdpoqj' ,'blogs': [
	    		{'name': '每月發票處理方式' , 'token': 'dnpwpoj' ,'views': 123 , 'user_avatar': '' ,'user': {'name': 'Tim Tsai', 'avatar': 'https://i0.wp.com/blog.longwin.com.tw/wp-content/uploads/2011/10/apple_hero_steve_jobs.png?fit=706%2C644&ssl=1'} ,'created_at': '2020-06-12', 'locked': true},
	    		{'name': '報稅流程' , 'token': 'dnpwpoj' ,'views': 123 , 'user_avatar': '' ,'user': {'name': 'Tim Tsai', 'avatar': 'https://i0.wp.com/blog.longwin.com.tw/wp-content/uploads/2011/10/apple_hero_steve_jobs.png?fit=706%2C644&ssl=1'} ,'created_at': '2020-06-12', 'locked': false},
    		]},
    	],
    	category: {},
    	editColumnName: "",
    	editColumnId: "",
    	dropItemPlaceholderOptions: {
        className: 'drop-preview',
        showOnTop: true
      },
      blog: "" ,
    }
  },
  created() {
  	this.getCategories();
  },
  props: ['toggle_aside'],
  computed: {

  },
  methods: {
  	getCategories(){
  		this.category = this.categories[0]
  	},
    canEditColumn(colmn_name,id){
      let vm = this
      if(vm.editColumnName == colmn_name && vm.editColumnId == id){
        return true
      }else{
        return false
      }
    },
    editColumn(name,id){
      let vm = this
      this.editColumnName = name
      this.editColumnId = id
      this.$nextTick(() => {
        if (Array.isArray(vm.$refs[name+id])){
          vm.$refs[name+id][0].focus()
        }else{
          vm.$refs[name+id].focus()
        }
      })
    },
    finishedEditColumn(){
      this.editColumnName = ""
      this.editColumnId = ""
    },
    onCategoryDrop (dropResult) {
      let vm = this
      vm.categories = applyDrag(vm.categories, dropResult)
      //ajax 更新order
      // this.axios.post('finances/money_categories/update_order', {
      //   categories: vm.filteCategoriesByType(type),
      //   type: type,
      // })
      // .then(function(response) {
      //   if (response.status == 200 && response['data']['status']== 'success') {
          
      //   } else {
      //   	vm.$toastr.w('更新失敗，已通知管理員進行障礙排除，請稍後再試')
          
      //   }
      // })
      // .catch(function(error) {
      // 	vm.$toastr.w('更新失敗，已通知管理員進行障礙排除，請稍後再試')
        
      // });
    },
     onItemDrop (dropResult) {
      let vm = this
      vm.category.blogs = applyDrag(vm.category.blogs, dropResult)
      //ajax 更新order
      // this.axios.post('finances/money_categories/update_order', {
      //   categories: vm.filteCategoriesByType(type),
      //   type: type,
      // })
      // .then(function(response) {
      //   if (response.status == 200 && response['data']['status']== 'success') {
          
      //   } else {
      //   	vm.$toastr.w('更新失敗，已通知管理員進行障礙排除，請稍後再試')
          
      //   }
      // })
      // .catch(function(error) {
      // 	vm.$toastr.w('更新失敗，已通知管理員進行障礙排除，請稍後再試')
        
      // });
    },
    dragStart () {
      // console.log('drag started')
    },
  },
}
</script>




// WEBPACK FOOTER //
// KnowledgeBaseBoard.vue?726187b2